/* Scentedelic · Build Your Own Box
   One native select per slot, following the Heretic Parfum bundle pattern.
   Config comes from data attributes so this file never needs Liquid. */
(function () {
  function wire(root) {
    if (root.dataset.wired === '1') return;
    root.dataset.wired = '1';

    var allowDupes = root.dataset.allowDupes === '1';
    var prefix = root.dataset.codePrefix || '';
    var fmt = root.dataset.moneyFormat || '';

    /* one <template> of options per pool; tabs (.sd-byob__pool) switch between them and a box is filled from one pool */
    var protos = Array.prototype.slice.call(root.querySelectorAll('.sd-byob__proto'));
    var poolBtns = Array.prototype.slice.call(root.querySelectorAll('.sd-byob__pool'));
    var pool = protos[0] ? (protos[0].dataset.pool || '1') : '1';

    function proto() {
      for (var i = 0; i < protos.length; i++) {
        if ((protos[i].dataset.pool || '1') === pool) return protos[i];
      }
      return protos[0];
    }
    var slotsEl = root.querySelector('.sd-byob__slots');
    var countBtns = Array.prototype.slice.call(root.querySelectorAll('.sd-byob__count'));
    var cta = root.querySelector('.sd-byob__cta');
    var nEl = root.querySelector('.sd-byob__n');
    var targetEl = root.querySelector('.sd-byob__target');
    var fillEl = root.querySelector('.sd-byob__fill');
    var sumEl = root.querySelector('.sd-byob__sum');
    var errEl = root.querySelector('.sd-byob__err');

    var target = 0;

    /* Wooden box: after the bottles are in the cart, add the box variant named
       "<size> Set of <count>" (for example "50ml Set of 3") from the box product,
       if it is in stock. The size comes from the bottles just added. data-box-handle overrides the product.
       The box is free for BYOB only through the discount code PREFIX-COUNT (page setting "Discount code prefix",
       e.g. BYOB50 gives BYOB50-3), which is applied only when the box was added (10 Oct 2026). Single scents
       bought outside BYOB never get the box free. */
    /* 29 Oct 2026: the box is no longer free or added automatically (operator). Auto-add runs only if the
       builder sets data-box-auto="1"; otherwise shoppers add a box themselves from the cart drawer, at its price. */
    var boxHandle = root.dataset.boxAuto === '1' ? (root.dataset.boxHandle || 'wooden-box-add-on') : '';

    function addBox(added, n) {
      var items = (added && added.items) || [];
      var m = null;
      for (var i = 0; i < items.length && !m; i++) {
        m = String(items[i].variant_title || '').match(/(\d+)\s*ml/i);
      }
      if (!m || !boxHandle) return Promise.resolve(false);
      var want = m[1] + 'mlsetof' + n;
      return fetch('/products/' + encodeURIComponent(boxHandle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var vs = (p && p.variants) || [];
          for (var k = 0; k < vs.length; k++) {
            var t = String(vs[k].title || '').toLowerCase().replace(/\s/g, '');
            if (t === want && vs[k].available) {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: vs[k].id, quantity: 1 }] })
              }).then(function (r) { return r.ok; });
            }
          }
          return false;
        })
        .catch(function () { return false; });
    }

    function money(cents) {
      var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
      var parts = v.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var num = parts.join('.');
      if (!fmt) return num;
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, num);
    }

    function selects() {
      return Array.prototype.slice.call(slotsEl.querySelectorAll('.sd-byob__select'));
    }

    function chosenValues() {
      return selects().map(function (s) { return s.value; }).filter(Boolean);
    }

    /* grey out scents already picked in another slot */
    function syncDupes() {
      var used = chosenValues();
      selects().forEach(function (s) {
        Array.prototype.forEach.call(s.options, function (o) {
          if (!o.value) return;
          if (o.dataset.soldout === '1') { o.disabled = true; return; }
          o.disabled = allowDupes ? false : (used.indexOf(o.value) > -1 && o.value !== s.value);
        });
      });
    }

    function refreshRow(sel) {
      var row = sel.closest('.sd-byob__row');
      var opt = sel.selectedOptions && sel.selectedOptions[0];
      var img = row.querySelector('.sd-byob__img');
      var ph = row.querySelector('.sd-byob__ph');
      var src = opt ? opt.dataset.img : '';
      if (src) {
        img.src = src;
        img.alt = opt.textContent.trim();
        img.hidden = false;
        if (ph) ph.hidden = true;
      } else {
        img.removeAttribute('src');
        img.hidden = true;
        if (ph) ph.hidden = false;
      }
      row.classList.toggle('is-filled', !!(opt && opt.value));
    }

    function render() {
      var filled = 0;
      var total = 0;
      selects().forEach(function (s) {
        var opt = s.selectedOptions && s.selectedOptions[0];
        if (opt && opt.value) {
          filled++;
          total += parseInt(opt.dataset.price, 10) || 0;
        }
      });
      nEl.textContent = filled;
      targetEl.textContent = target;
      fillEl.style.width = target ? Math.min(100, (filled / target) * 100) + '%' : '0%';
      sumEl.textContent = filled ? money(total) : '';
      cta.disabled = !(target > 0 && filled === target);
    }

    function buildSlots(n) {
      var keep = selects().map(function (s) { return s.value; });
      slotsEl.textContent = '';
      for (var i = 0; i < n; i++) {
        var frag = proto().content.cloneNode(true);
        var sel = frag.querySelector('.sd-byob__select');
        var num = frag.querySelector('.sd-byob__slotnum');
        var lab = frag.querySelector('.sd-byob__slotlabel');
        sel.id = root.dataset.sectionId + '-slot-' + i;
        sel.name = 'items[' + i + ']id';
        sel.dataset.slot = String(i);
        if (lab) lab.setAttribute('for', sel.id);
        if (num) num.textContent = i + 1;
        if (keep[i]) {
          sel.value = keep[i];
        }
        sel.addEventListener('change', function (e) {
          refreshRow(e.target);
          syncDupes();
          render();
        });
        slotsEl.appendChild(frag);
        refreshRow(slotsEl.querySelector('.sd-byob__row:last-child .sd-byob__select'));
      }
      syncDupes();
      render();
    }

    function setTarget(n) {
      target = n;
      countBtns.forEach(function (b) {
        var on = parseInt(b.dataset.count, 10) === n;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      buildSlots(n);
    }

    countBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        setTarget(parseInt(b.dataset.count, 10));
      });
    });

    function setPool(p) {
      if (p === pool) return;
      pool = p;
      poolBtns.forEach(function (b) {
        var on = b.dataset.pool === p;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      slotsEl.textContent = '';
      buildSlots(target);
    }

    poolBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        setPool(b.dataset.pool);
      });
    });

    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      errEl.hidden = true;
      cta.classList.add('is-busy');

      var tally = {};
      selects().forEach(function (s) {
        if (!s.value) return;
        tally[s.value] = (tally[s.value] || 0) + 1;
      });
      var payload = Object.keys(tally).map(function (id) {
        return { id: parseInt(id, 10), quantity: tally[id] };
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload })
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
            return body;
          });
        })
        .then(function (added) {
          return addBox(added, target);
        })
        .then(function (boxAdded) {
          var code = prefix && boxAdded ? prefix + '-' + target : '';
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=/cart'
            : '/cart';
        })
        .catch(function (err) {
          cta.classList.remove('is-busy');
          errEl.textContent = err.message;
          errEl.hidden = false;
        });
    });

    var first = countBtns[0];
    setTarget(first ? parseInt(first.dataset.count, 10) : 0);
  }

  function init() {
    document.querySelectorAll('.sd-byob').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();